import { ACTIONS_TYPES } from "../utils/constants";

export const initialState = {
  meters: null,
  createdMeter: null,

  error: null,
  loader: null,
  success: false,
};

export default function stockControllerReducer(state = initialState, action) {
  switch (action.type) {

    case ACTIONS_TYPES.FETCH_METERS_REQUEST:
      return { ...state, loader: true, error: null, success: false };

    case ACTIONS_TYPES.FETCH_METERS_SUCCESS:
      return { ...state, meters: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.FETCH_METERS_FAILED:
      return { ...state, loader: false, error: action.payload };
      
    case ACTIONS_TYPES.FETCH_METERS_RESET:
      return { ...initialState  };



    case ACTIONS_TYPES.REGISTER_METER_REQUEST:
      return { ...state, loader: true, error: null, success: false };

    case ACTIONS_TYPES.REGISTER_METER_SUCCESS:
      return { ...state, createdMeter: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.REGISTER_METER_FAILED:
      return { ...state, loader: false, error: action.payload };

    default:
      return state;
  }
}